module.exports = __webpack_public_path__ + "images/ca373649.png";